import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ResponseMessageType,
  ApiMembersEmployeeSurveysEmployeeSurveySubmissionsMutationRequestType,
} from "~/domains";

type RequestDataType = {
  employeeSurveyId: string;
  body: ApiMembersEmployeeSurveysEmployeeSurveySubmissionsMutationRequestType;
};

const request = ({ employeeSurveyId, body }: RequestDataType) => {
  return new ApiClient()
    .post<ResponseMessageType & { employeeSurveySubmissionId: string }>(
      `/api/members/employee_surveys/${employeeSurveyId}/employee_survey_submissions`,
      {
        employeeSurveySubmission: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersEmployeeSurveysEmployeeSurveySubmissionsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ResponseMessageType & { employeeSurveySubmissionId: string },
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
